module.exports = __webpack_public_path__ + "static/media/dinersclub-dark.baff56e3.svg";